export default __webpack_public_path__ + "static/media/SeaLife_04.85467fac.png";